import { GetFromStorage } from '@/vessi.utils';

// initial state	
export default () => ({
	username: !!GetFromStorage('user')?GetFromStorage('user'):'',
	siiToken: '',
	isloading: false,
	auth:{
		status: null,
		error:''
	},
	permisos:[],
	esRepresentante: false,
	isloadingPermisos: false,
	consultas:[]
});